import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Home from '@/components/Home/Home'
import SharePlayer from '@/components/SharePlayer'
import 'promise-polyfill/src/polyfill'
import 'whatwg-fetch'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      label: 'HOME', // displayed as Link Label (if falsy, it won't be displayed)
      component: Home
    },
    {
      path: '/extra/share-player',
      name: 'SharePlayer',
      label: 'SHARE PLAYER',
      component: SharePlayer
    },

    // 確認用
    {
      path: '/test/hoge',
      name: 'Test',
      component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js